import React from 'react';
import { Link } from 'react-router-dom';

interface FooterProps {
  onShowAbout: () => void;
}

const Footer: React.FC<FooterProps> = ({ onShowAbout }) => {
  return (
    <footer className="App-footer">
      <div className="container py-5">
        <div className="row g-4">
          <div className="col-lg-4 col-md-6">
            <div className="d-flex align-items-center mb-3">
              <img src="/logo.png" alt="Logo" style={{ height: '32px', marginRight: '10px' }} />
              <span className="fw-bold h5 mb-0 text-white">
                <span style={{ color: '#3b82f6' }}>AI</span> ShoppingCart
              </span>
            </div>
            <p className="text-muted small">
              Building intelligent tools to simplify your shopping experience.
              Our AI-powered cart helps you find the best deals across the web effortlessly.
            </p>
          </div>

          <div className="col-lg-2 col-md-6">
            <h6 className="fw-bold mb-3 text-white">Product</h6>
            <ul className="list-unstyled small">
              <li className="mb-2">
                <button
                  onClick={onShowAbout}
                  className="btn btn-link p-0 text-muted text-decoration-none hover-white small border-0 shadow-none"
                  style={{ fontSize: 'inherit' }}
                >
                  How it works
                </button>
              </li>
              <li className="mb-2"><Link to="/privacy-policy" className="text-muted text-decoration-none hover-white">Privacy Policy</Link></li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6">
            <h6 className="fw-bold mb-3 text-white">Community</h6>
            <ul className="list-unstyled small">
              <li className="mb-2">
                <a href="https://essentialx.us" target="_blank" rel="noopener noreferrer" className="text-muted text-decoration-none hover-white">
                  <i className="mb-2"></i>About Us
                </a>
              </li>
              <li className="mb-2">
                <a href="https://www.linkedin.com/company/essentialx/" target="_blank" rel="noopener noreferrer" className="text-muted text-decoration-none hover-white">
                  <i className="mb-2"></i>LinkedIn
                </a>
              </li>
              <li className="mb-2">
                <a href="mailto:contact@essentialx.us" className="text-muted text-decoration-none hover-white">
                  <i className="mb-2"></i>Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6">
            <h6 className="fw-bold mb-3">Required Extension</h6>
            <a href="https://chromewebstore.google.com/detail/ai-shopping-cart/bhpgolaacmlhpoflfomangjboeombkkg" target="_blank" rel="noopener noreferrer">
              <img src="/chrome-web-store-badge.png" alt="Chrome Web Store" style={{ height: '40px' }} />
            </a>
          </div>
        </div>

        <hr className="my-4 opacity-10" />

        <div className="row align-items-center">
          <div className="col-md-6 text-center text-md-start">
            <span className="text-muted small">© 2026 Essential X. All Rights Reserved.</span>
          </div>
          <div className="col-md-6 text-center text-md-end mt-3 mt-md-0">
            <span className="text-muted small">Built with <i className="bi bi-heart-fill text-danger mx-1"></i> for shoppers.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
